function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentSharing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.22,26.36H26.78v2.89H15.22Zm0-5.79H26.78v2.9H15.22ZM23.89,6.11H12.32A2.9,2.9,0,0,0,9.43,9V32.14A2.89,2.89,0,0,0,12.31,35H29.68a2.9,2.9,0,0,0,2.89-2.89V14.79Zm5.79,26H12.32V9H22.45v7.23h7.23Z",
    style: {
      fill: "#62a3ef"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentSharing);
export default __webpack_public_path__ + "static/media/document_sharing.fcf53744d73c2d47a0f4fedf46d4852b.svg";
export { ForwardRef as ReactComponent };